module.exports = __webpack_public_path__ + "img/img12.af3cea22.svg";